import { render } from "./CozeSuper.vue?vue&type=template&id=dace4d94&scoped=true"
import script from "./CozeSuper.vue?vue&type=script&lang=js"
export * from "./CozeSuper.vue?vue&type=script&lang=js"

import "./CozeSuper.vue?vue&type=style&index=0&id=dace4d94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dace4d94"]])

export default __exports__